import { render } from "./product-card-list.vue?vue&type=template&id=482166c2&scoped=true&ts=true"
import script from "./product-card-list.vue?vue&type=script&lang=ts"
export * from "./product-card-list.vue?vue&type=script&lang=ts"

import "./product-card-list.vue?vue&type=style&index=0&id=482166c2&scoped=true&lang=css"
import "./product-card-list.vue?vue&type=style&index=1&id=482166c2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482166c2"]])

export default __exports__